var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 79.1666V20.8333C16.6667 13.9291 22.2626 8.33331 29.1668 8.33331H58.3334L83.3334 33.3333V79.1666C83.3334 86.0708 77.7376 91.6666 70.8334 91.6666H29.1668C22.2626 91.6666 16.6667 86.0708 16.6667 79.1666Z",
    fill: "#F4F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 25V8.33331L83.3333 33.3333H66.6666C62.0624 33.3333 58.3333 29.6041 58.3333 25Z",
    fill: "url(#paint0_linear_343_24632)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4999 54.1666H37.4999C35.1958 54.1666 33.3333 52.3 33.3333 50C33.3333 47.7 35.1958 45.8333 37.4999 45.8333H62.4999C64.8041 45.8333 66.6666 47.7 66.6666 50C66.6666 52.3 64.8041 54.1666 62.4999 54.1666Z",
    fill: "url(#paint1_linear_343_24632)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1666 70.8333H37.4999C35.1958 70.8333 33.3333 68.9667 33.3333 66.6667C33.3333 64.3667 35.1958 62.5 37.4999 62.5H54.1666C56.4708 62.5 58.3333 64.3667 58.3333 66.6667C58.3333 68.9667 56.4708 70.8333 54.1666 70.8333Z",
    fill: "url(#paint2_linear_343_24632)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_24632",
    x1: 70.8333,
    y1: 8.33331,
    x2: 70.8333,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_24632",
    x1: 49.9999,
    y1: 45.8333,
    x2: 49.9999,
    y2: 54.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_24632",
    x1: 45.8333,
    y1: 62.5,
    x2: 45.8333,
    y2: 70.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.31c6ca7ac9fd7f20fd1a73bf88391b32.svg";
export { ForwardRef as ReactComponent };